import { apiCall } from './gqlClient';

const GETMYBODYMEASUREMENTS_QUERY = `
  query getMyBodyMeasurements {
    getMyBodyMeasurements
    {
      id
			leanMass
			boneMass
			visceralFat
			leftBiceps
			rightBiceps
			chest
			waist
			hips
			leftLeg
			rightLeg
			leftCalf
			rightCalf
			height
			weight
			dateCreated
      ...fragments
    }
  }`;

export const getMyBodyMeasurementsApiCall = async (fragments = null) => apiCall({ query: GETMYBODYMEASUREMENTS_QUERY, variables: {}, fragments });

const GETMYGOALS_QUERY = `
  query getMyGoals {
    getMyGoals
    {
      id
			type
			goal
			completed
			dateCreated
			dateCompleted
      ...fragments
    }
  }`;

export const getMyGoalsApiCall = async (fragments = null) => apiCall({ query: GETMYGOALS_QUERY, variables: {}, fragments });

const GETMYBODYMEASUREMENTSGRAPH_QUERY = `
  query getMyBodyMeasurementsGraph {
    getMyBodyMeasurementsGraph
    {
      id
			leanMass
			boneMass
			visceralFat
			leftBiceps
			rightBiceps
			chest
			waist
			hips
			leftLeg
			rightLeg
			leftCalf
			rightCalf
			height
			weight
			dateCreated
      ...fragments
    }
  }`;

export const getMyBodyMeasurementsGraphApiCall = async (fragments = null) => apiCall({ query: GETMYBODYMEASUREMENTSGRAPH_QUERY, variables: {}, fragments });

const UPDATEMYBODYMEASUREMENTS_QUERY = `
  mutation updateMyBodyMeasurements($request: UserBodyMeasurementsInput!) {
    updateMyBodyMeasurements(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateMyBodyMeasurementsApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEMYBODYMEASUREMENTS_QUERY, variables: {request}, fragments });

const UPDATEMYGOALS_QUERY = `
  mutation updateMyGoals($request: [UserGoalInput]!) {
    updateMyGoals(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateMyGoalsApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEMYGOALS_QUERY, variables: {request}, fragments });

const DELETEMYGOAL_QUERY = `
  mutation deleteMyGoal($id: String!) {
    deleteMyGoal(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const deleteMyGoalApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEMYGOAL_QUERY, variables: {id}, fragments });
